import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../../assets/Images/login_back.png";
import samparkLogo from "../../assets/Images/SamparkLogo.png";
import Login from "./Login";
import Register from "./Register";
import CustomCarousel from "../../components/common/CustomCarousel";

const Auth = () => {
  const [isSignIn, setIsSignIn] = useState(true);
  const navigate = useNavigate();

  const toggleForm = () => {
    setIsSignIn(!isSignIn);
    const newPath = isSignIn ? "/auth/register" : "/auth/login";
    navigate(newPath);
  };

  useEffect(() => {
    const newPath = !isSignIn ? "/auth/register" : "/auth/login";
    navigate(newPath);
  }, []);

  return (
    <div className="min-h-screen bg-cover bg-center relative flex justify-around items-center">
      
      {/* <div className="hidden sm:block absolute inset-0 bg-black opacity-20"></div> */}
      <div className="hidden sm:block absolute inset-0 ">
        <img
          src={backgroundImage}
          alt="Background"
          className="w-full h-full object-cover opacity-50"
        />
      </div>
      <div className="w-[60%] h-[33rem] bg-black rounded-md">
        <CustomCarousel />
      </div>
      <div
        className="flex items-center justify-center flex-col relative z-10 w-full md:max-w-md bg-white rounded-lg shadow-2xl"
        style={{
          minHeight: isSignIn ? "33rem" : "33rem",
          width: isSignIn ? "28rem" : "28rem",
        }}
      >
        <div className="sm:mx-auto sm:w-full sm:max-w-sm absolute top-[18px]">
          <img
            className="mx-auto w-auto h-[45px]"
            src={samparkLogo}
            alt={samparkLogo}
          />
        </div>
        {isSignIn ? (
          <Login isSignIn={isSignIn} toggleForm={toggleForm} />
        ) : (
          <Register isSignIn={isSignIn} toggleForm={toggleForm} />
        )}
      </div>
    </div>
  );
};

export default Auth;
